import {Grid} from '@mantine/core';
import type {FC} from 'react';

/**
 * Two-column layout: main content and an optional side pane. Renders
 * children bare (no grid) when no pane is provided.
 * @registry 12/9 + 12/3 split grid with optional side pane, xl breakpoint.
 *
 * Ported from `library/forms/FormViewSplitPane`. Renamed
 * `FormViewSplitPane` -> `SplitPane`. Prop surface kept identical.
 */
export interface SplitPaneProps {
  pane?: React.ReactNode;
  children?: React.ReactNode;
}

export const SplitPane: FC<SplitPaneProps> = ({pane, children}) => {
  return pane === undefined ? (
    <>{children}</>
  ) : (
    <Grid>
      <Grid.Col
        span={{
          base: 12,
          xl: 9,
        }}>
        {children}
      </Grid.Col>
      <Grid.Col
        span={{
          base: 12,
          xl: 3,
        }}>
        {pane}
      </Grid.Col>
    </Grid>
  );
};
